import React, {useEffect, useRef} from "react"

export interface ClickOutsideHandlerProps {
  onClickedOutside: () => void
}

export const ClickOutsideHandler: React.FC<ClickOutsideHandlerProps> = ({onClickedOutside, children}) => {
  const insideArea = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function ClickHandler(e: Event) {
      if (insideArea.current == null) return
      const eventTarget = e.target as Node
      if (insideArea.current.contains(eventTarget)) return
      onClickedOutside()
    }

    document.addEventListener("mousedown", ClickHandler)
    return () => {
      document.removeEventListener("mousedown", ClickHandler)
    }
  }, [onClickedOutside])

  return <div ref={insideArea}>
    {children}
  </div>
}
